import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { faCar, faIndustry } from '@fortawesome/free-solid-svg-icons'

import ReportCard from './partials/ReportCard'
import DownloadReportModal from './partials/DownloadReportModal'
import PageTitle from '../Settings/partials/PageTitle'

export default function ReportsDashboard() {
	const [showModal, setShowModal] = useState(null)

	const items = [
		{
			title: 'Cumplimiento de los horarios de citas por proveedor',
			subtitle: 'Reporte de cumplimiento de los horarios de citas por proveedor',
			icon: faIndustry,
			onClick: () => setShowModal({
				title: 'Cumplimiento de los horarios de citas por proveedor',
				slug: 'compliance_by_supplier',
				yearFilter: true,
				monthFilter: true,
			})
		},
		{
			title: "Cumplimiento de los tiempos de descargue por tipo de vehículo",
			subtitle: "Reporte de cumplimiento de los tiempos de descargue por tipo de vehículo",
			icon: faCar,
			onClick: () => setShowModal({
				title: "Cumplimiento de los tiempos de descargue por tipo de vehículo",
				slug: 'unload_times_by_vehicle_type',
				yearFilter: true,
				monthFilter: true,
			})
		},
	]

	return (
		<React.Fragment>
			<PageTitle title="Reportes Gestión de Citas" subtitle="Plataforma CENF Spring." />
			<Row>
				{ items.map(item => (
					<Col key={item.title} sm="12" md="6" lg="4" className="mb-10">
						<ReportCard 
							title={item.title}
							subtitle={item.subtitle}
							icon={item.icon}
							onClick={item.onClick}
						/>
					</Col>
				)) }
			</Row>
			{ showModal && (
				<DownloadReportModal
					visible
					onClose={() => setShowModal(null)}
					data={showModal}
				/>
			)}
		</React.Fragment>
	)
}